import React from 'react'
import { useIntl } from 'react-intl'
import Link from 'next/link'
import { Typography } from '@s4l/ds'
import styles from './index.module.css'

const TermsSection: React.FC = () => {
  const intl = useIntl()

  return (
    <div className={styles.termsContainer}>
      <Typography variant="body" size="m" as="p">
        {intl.formatMessage(
          {
            id: 'global.accept-conditions-continuing',
          },
          {
            terms: (
              <Link href="/general-conditions" passHref>
                <a className={styles.termsLink}>{intl.formatMessage({ id: 'legal.terms' })}</a>
              </Link>
            ),
            privacy: (
              <Link href="/privacy" passHref>
                <a className={styles.termsLink}>{intl.formatMessage({ id: 'global.privacy' })}</a>
              </Link>
            ),
          }
        )}
      </Typography>
    </div>
  )
}

export default TermsSection
